import React from 'react';

import Framework from "@beardeddevops/react.framework"
import {Objects, Collections} from "components";

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const breadcrumbsStatic = [{
	name: 'Dispatch',
	url: '/dispatch',
	icon: 'dashboard',
}];

export default class ScheduleRouting extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state = {
			customer_name: '',
			customer_address: '',
			field_engineer: '',
			saveTicket: false,
			filterEngineer: null,
			mapsUrls: [],
			filterDate: new Date().getDate(),
			calendarReload: false,
		};
	}

	updateSchedule = (updatedInfo) => {
		this.setState({scheduleInfo: updatedInfo})
	}

	updateFilter = (filterEngineer) => {
		this.setState({filterEngineer});
	}

	updateTime = (getFilterDate) => {
		this.setState({getFilterDate : new Date(getFilterDate)});
	}

	reloadCalendar = () => {
		this.setState({calendarReload: !this.state.calendarReload})
	}

	render() {
		let {match, history} = this.props;

		let breadcrumbs = breadcrumbsStatic.concat([
			{
				name: 'Closest Field Engineer',
				url: `/closest`,
				icon: 'calendar',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Card>
					<CardContent>
						<div className={'row'}>
							<div className={'col-12'}>
								<Objects.ScheduleMapRouting
									id={match.params.id}
									scheduleInfo={this.state.scheduleInfo}
									history={this.props.history}
									reloadShell={this.props.reloadShell}
									reloadPage={this.refreshPage}
									reloadSelf={this.state.refresh}
									updateName={this.updateName}
									baseUrl={this.props.baseUrl}
									saveSelf={this.state.saveTicket}
									// updateFilter={this.updateFilter}
									// updateTime={this.updateTime}
									// provideLocation={(customer_name, customer_address, field_engineer) => {
									// 	this.setState({
									// 		customer_name: customer_name,
									// 		customer_address: customer_address,
									// 		field_engineer: field_engineer
									// 	});
									// }}
									mapsUrls={this.state.mapsUrls}
									reloadCalendar={this.reloadCalendar}
								/>
							</div>
						</div>
					</CardContent>
				</Card>

			</div>
		)
	}
};
